import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../ui/alert-dialog";
import { Loader2, Send, Trash2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const errMsg = (e) => e?.response?.data?.detail || e?.message || "inconnue";

export const NewsletterRowActions = ({ item, index, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  const [typed, setTyped] = useState("");
  const isConfirmed = item.status === "confirmed";

  const resend = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/admin/newsletter/subscribers/${item.id}/resend`);
      if (r.data?.status === "sent") toast.success(`Email de confirmation renvoyé à ${item.email}.`);
      else toast.error(`Renvoi non effectué (${r.data?.status}${r.data?.error ? " : " + r.data.error : ""}).`);
      onChanged();
    } catch (e) {
      toast.error("Renvoi échoué : " + errMsg(e));
    } finally { setBusy(false); }
  };

  const remove = async () => {
    setBusy(true);
    try {
      await axios.delete(`${API}/admin/newsletter/subscribers/${item.id}`);
      toast.success(`${item.email} supprimé de la newsletter.`);
      setOpen(false);
      onChanged();
    } catch (e) {
      toast.error("Suppression échouée : " + errMsg(e));
    } finally { setBusy(false); }
  };

  return (
    <div className="flex items-center gap-1">
      {item.status === "pending" && (
        <Button variant="ghost" size="sm" onClick={resend} disabled={busy || !item.id} data-testid={`newsletter-resend-btn-${index}`}>
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Send className="h-3.5 w-3.5" />}
          <span className="ml-1 text-xs">Renvoyer</span>
        </Button>
      )}
      <Button variant="ghost" size="sm" className="text-red-700" onClick={() => { setTyped(""); setOpen(true); }} disabled={busy || !item.id} data-testid={`newsletter-delete-btn-${index}`}>
        <Trash2 className="h-3.5 w-3.5" /><span className="ml-1 text-xs">Supprimer</span>
      </Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="newsletter-delete-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Supprimer cet abonné newsletter ?</AlertDialogTitle>
            <AlertDialogDescription>
              Seule l'inscription newsletter de <strong>{item.email}</strong> sera supprimée. Aucun compte, adhésion ou autre donnée n'est touché. Action irréversible.
              {isConfirmed && " Cet abonné a confirmé son inscription : tapez SUPPRIMER pour valider."}
            </AlertDialogDescription>
          </AlertDialogHeader>
          {isConfirmed && (
            <Input value={typed} onChange={(e) => setTyped(e.target.value)} placeholder="SUPPRIMER" data-testid="newsletter-delete-confirm-input" />
          )}
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="newsletter-delete-cancel-btn">Annuler</AlertDialogCancel>
            <AlertDialogAction
              onClick={(e) => { e.preventDefault(); remove(); }}
              disabled={busy || (isConfirmed && typed !== "SUPPRIMER")}
              className="bg-red-700 hover:bg-red-800"
              data-testid="newsletter-delete-confirm-btn"
            >
              Supprimer
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
